<template>
  <div class="detail-wrapper">
    <div class="prodet-bg">
      <div class="container">
        <div class="por-box-location">
          <Icon custom="ich-icon ich-icon-map" size="18" />
          <span>{{ productInfo.name }} | 包含班级： <span>正在播放</span></span>
          <div class="product-course">
            <span>
              {{ courseInfo.courseName }}
              <Icon type="md-arrow-dropdown" />
            </span>
            <div class="product-course-ani">
              <ul class="product-course-drop">
                <li v-for="(item, index) in courseList" :key="index">
                  <a href="javascript:;">{{ item.courseName }}</a>
                  <div class="course-special">
                    <div
                      class="special-item"
                      v-for="(special, speIndex) in item.coursespecialtypeList"
                      :key="speIndex"
                    >
                      <a
                        href="javascript:;"
                        @click="changeCourseSpecial(item, special)"
                        >{{ special.specialName }}</a
                      >
                      <div class="can-live" v-if="special.hasLive">包含直播</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="prodet-player clearfix">
          <div class="prodet-box-c">
            <video-player
              :width="800"
              :loading="!isLoaded"
              :tipText="noVideoText"
            ></video-player>
          </div>
          <div class="prodet-box-d clearfix">
            <div class="prodet-boxd-a">
              <course-catalog v-if="currentSpecial.type === 1"></course-catalog>
              <review-catalog v-if="currentSpecial.type === 2"></review-catalog>
            </div>
            <div class="prodet-boxd-b">
              <div class="prodet-pt-a">
                <Icon custom="ich-icon ich-icon-catalog" />
                <p>目录</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 购买区域 -->
      <div class="container prodet-action clearfix">
        <div class="prodet-box-f">
          <p
            class="prodet-boxf-b"
            v-show="
              formatPrice(
                productInfo.reducedPrice,
                productInfo.marketPrice
              )[1] !== '-1'
            "
          >
            ¥{{
              formatPrice(productInfo.reducedPrice, productInfo.marketPrice)[1]
            }}
          </p>
          <p
            class="prodet-boxf-c"
            v-show="
              formatPrice(
                productInfo.reducedPrice,
                productInfo.marketPrice
              )[0] !== '-1'
            "
          >
            <span style="font-size: 22px">￥</span>
            <span id="product-price">{{
              formatPrice(productInfo.reducedPrice, productInfo.marketPrice)[0]
            }}</span>
          </p>
          <Button v-if="isBuy" disabled shape="circle">已购买</Button>
          <Button
            v-else-if="productInfo.reducedPrice"
            type="warning"
            shape="circle"
            @click="buyProduct"
            >立即购买</Button
          >
          <Button v-else disabled shape="circle">立即购买</Button>
        </div>
      </div>
    </div>

    <!-- 详情 -->
    <div class="container clearfix">
      <!-- 详情内容 -->
      <div class="product-detail">
        <div class="product-info-bar">课程介绍</div>
        <h3 class="product-info-title">
          {{ productInfo.name }}
        </h3>
        <ul class="product-info-body">
          <li
            v-show="
              Object.keys(productInfo).length > 0 &&
                siteConfig.isShowProductValid == 1
            "
          >
            <div class="info-item"><span>•</span> 有效期：</div>
            <div class="info-content">{{ productInfo.validTime }}</div>
          </li>
          <li>
            <div class="info-item"><span>•</span> 所属地区：</div>
            <div class="info-content">
              <em
                v-for="(item, index) in productInfo.provinceList"
                :key="index"
              >
                {{ item.name }} &nbsp;
              </em>
            </div>
          </li>
        </ul>
        <div>
          <h4 class="product-info-sub" style="float: left">
            包含班型（{{ productInfo.specialNum }}个）：
          </h4>
          <div style="float: right; padding: 15px 0 10px 0">
            <span class="product-info-btn" @click="showCourseFunc"
              >课程信息</span
            >
          </div>
        </div>
        <div style="clear: both"></div>
        <div class="product-course-list">
          <dl v-for="(item, index) in courseList" :key="index">
            <dt>[{{ item.courseNo }}]{{ item.courseName }}</dt>
            <dd
              v-for="(special, speIndex) in item.coursespecialtypeList"
              :key="speIndex"
            >
              <span :style="{ color: special.hasLive ? '#ff5f72' : '#333' }">{{
                special.specialName
              }}</span>
              <span style="color:#ff5f72" v-if="special.hasLive"
                >(包含直播)</span
              >
            </dd>
          </dl>
        </div>

        <div class="product-info-detail" v-html="productInfo.intro"></div>
      </div>

      <!-- 课程信息弹框 -->
      <Modal
        v-model="courseflag"
        :closable="true"
        :mask-closable="true"
        footer-hide
        class-name="vertical-center-modal"
      >
        <div
          style="
            text-align: center;
            max-height: 500px;
            overflow-y: auto;
            overflow-x: hidden;
            position: relative;
          "
        >
          <div
            style="
              text-align: left;
              font-size: 18px;
              font-weight: 600;
              position: fixed;
              background-color: #ffffff;
              width: 500px;
              line-height: 10px;
              height: 20px;
              border-bottom: 1px solid #cccccc;
            "
          >
            课程信息
          </div>
          <div style="width: 500px; height: 15px"></div>
          <div
            v-for="(special, index) in productCourse"
            style="border-bottom: 1px solid #cccccc"
            :key="index"
          >
            <div
              style="
                text-align: left;
                font-size: 18px;
                padding: 10px 0;
                font-weight: 600;
              "
            >
              {{ special.courseName }}
            </div>
            <template v-for="(cdpItem, cdpI) in special.courseSon.ppt">
              <div
                style="text-align: left; font-size: 18px; padding: 0 0 10px 0"
                :key="cdpI"
              >
                <span>•</span>{{ cdpItem.name }}：
                <span
                  >课时：<b class="color2">{{ cdpItem.ppttime }}</b
                  >分钟</span
                >
                <span style="padding: 0 0 0 15px"
                  >视频：<b class="color2">{{ cdpItem.pptnum }}</b
                  >个</span
                >
              </div>
            </template>
            <div style="height: 10px"></div>
            <template v-for="(cdeItem, cdeI) in special.courseSon.exe">
              <div
                style="text-align: left; font-size: 18px; padding: 0 0 10px 0"
                :key="cdeI"
              >
                <span>•</span>{{ cdeItem.name }}：
                <span class="info-content">
                  <span
                    ><b class="color2">{{ cdeItem.exernum }}</b
                    >题<b
                      class="color2"
                      style="padding: 0 0 0 15px"
                      v-if="cdeItem.specialids != '-'"
                      >{{ cdeItem.specialids }}</b
                    ><span v-if="cdeItem.specialids != '-'">套</span></span
                  >
                </span>
              </div>
            </template>
          </div>
        </div>
      </Modal>

      <!-- 侧边栏 -->
      <div class="product-sider">
        <div class="product-info-bar">师资简介</div>
        <teacher-slider :dataList="teacherList"></teacher-slider>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { mall } from "../../request";
import { saveBuyProduct } from "../../utils/localStorage";

import VideoPlayer from "../../components/common/VideoPlayer";
import CourseCatalog from "./CourseCatalog";
import ReviewCatalog from "../../components/mall/ReviewCatalog";
import TeacherSlider from "./TeacherSlider";

export default {
  mixins: [siteMixin],
  data() {
    return {
      courseList: [],
      currentSpecial: {}, //当前班型
      noVideoText: "",
      teacherList: [],
      productInfo: {},
      courseInfo: {},
      isLoaded: false,
      courseflag: false,
      productCourse: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    //显示课程信息
    showCourseFunc() {
      this.courseflag = true;
    },
    //关闭
    closeCourseFunc() {
      this.courseflag = false;
    },
    getData() {
      const productId = this.$route.params.id;
      this.setProductId(productId);
      mall.productCourseDetail(this.productId).then((res) => {
        if (res.status == 1) {
          this.productCourse = res.data;
        }
      });
      mall
        .getProductInfo(
          this.siteConfig.agencyId,
          this.productId,
          this.loginUser.userId ?? 0
        )
        .then((res) => {
          //console.log(res);
          if (res.status == 1) {
            const result = res.data;
            this.productInfo = result.product;
            this.courseList = result.courseList;
            //this.productList = result.productList;
            this.teacherList = result.teacherList;
            this.setIsBuy(result.isBuy == 0 ? false : true);

            if (this.courseList.length > 0) {
              //课程处理
              const videoCourse = this.courseList.find(
                (m) => m.isTryLook === 1
              );
              if (videoCourse) {
                this.courseInfo = videoCourse;
              } else {
                this.courseInfo = this.courseList[0];
              }
              this.setCourseId(this.courseInfo.courseId);

              //班型处理
              if (
                this.courseInfo.coursespecialtypeList &&
                this.courseInfo.coursespecialtypeList.length > 0
              ) {
                const videoSpecial = this.courseInfo.coursespecialtypeList.find(
                  (m) => m.isTryLook === 1
                );
                if (videoSpecial) {
                  this.currentSpecial = videoSpecial;
                } else {
                  this.currentSpecial = this.courseInfo.coursespecialtypeList[0];
                }
                this.setCourseSpecialId(this.currentSpecial.cstId);
              }
              this.getCourseCatalog();
            }
            this.setMetaData(this.productInfo.name);
          }
        });
    },
    changeCourseSpecial(item, special) {
      if (special.cstId == this.courseSpecialId) return;
      this.currentProduct = item;
      this.setCourseId(item.courseId);
      this.currentSpecial = special;
      this.setCourseSpecialId(special.cstId);
      this.getCourseCatalog();
    },
    //商品购买
    buyProduct() {
      saveBuyProduct(this.productId, 1);
      this.$router.push({ name: "BuyProduct" });
    },
    //获取课程目录
    getCourseCatalog() {
      // this.setCourseCatalog([]);
      // this.setReviewCatalog([]);
      mall
        .getCourseCatalog(
          this.courseId,
          this.courseSpecialId,
          this.currentSpecial.type,
          this.loginUser.userId,
          this.siteConfig.agencyId
        )
        .then((res) => {
          //console.log("catalog", res);
          if (res.status === 1) {
            //this.courseCatalog = res.data;
            this.isLoaded = true;

            //无目录时处理
            if (!res.data || res.data.length == 0) {
              this.setCourseCatalog([]);
              this.setPptId("");
              this.setVideoId("");
              if (this.currentSpecial.type === 2) {
                this.noVideoText = "该班型视频正在准备中";
              }
            }

            //章节
            if (this.currentSpecial.type === 1) {
              this.setCourseCatalog(res.data);
              //查找并设置视频ID
              if (res.data.length > 0) {
                const one = res.data[0];
                if (one.childList && one.childList.length > 0) {
                  const two = one.childList[0];
                  if (two.childList && two.childList.length > 0) {
                    const three = two.childList[0];
                    if (three.isTryLook == 1) {
                      this.setVideoId(three.bVideoId);
                    } else {
                      this.noVideoText =
                        "当前课程视频不支持试看，请购买后进行学习";
                    }
                  }
                }
              }
            }
            //串讲
            if (
              this.currentSpecial.type === 2 &&
              res.data &&
              res.data.length > 0
            ) {
              const reviewPptList = res.data[0].pptList || [];
              const liveList = res.data[0].live;
              let resultList = [];
              if (reviewPptList && reviewPptList.length) {
                resultList = reviewPptList.map((m) => {
                  return {
                    type: 1,
                    ...m,
                  };
                });
              }
              if (liveList && liveList.length) {
                const liveTemp = liveList.map((m) => {
                  return {
                    type: 2,
                    isTryLook: 0,
                    ...m,
                  };
                });
                resultList = [...resultList, ...liveTemp];
              }
              if (
                (resultList && resultList.length) ||
                (reviewPptList && reviewPptList.length > 0)
              ) {
                this.setReviewCatalog(resultList);
                let current = reviewPptList[0];
                if (current.isTryLook === 1) {
                  this.setPptId(current.PptId);
                  this.setVideoId(current.bVideoId);
                } else {
                  this.noVideoText = "当前课程视频不支持试看，请购买后进行学习";
                }
              }
            }
          }
        });
    },
  },
  components: {
    VideoPlayer,
    CourseCatalog,
    ReviewCatalog,
    TeacherSlider,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
.detail-wrapper {
  background: url("../../assets/images/v3/product-detail-bg.png") no-repeat
    bottom;
}
//课程信息按钮
.product-info-btn {
  width: 92px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  background: linear-gradient(to right, #27a3ff, #2380fb);
  transition: transform 0.2s ease;
}

// 播放器
.prodet-bg {
  background: #2f3133 url("../../assets/images/v3/player-bg-p.png") no-repeat
    top;
  width: 100%;
  padding-top: 70px;
  .por-box-location {
    height: 70px;
    line-height: 70px;
    color: #999;
    font-size: 16px;
    & > i {
      vertical-align: -0.08em;
    }
    span {
      .inline-block();
      margin-left: 10px;
      span {
        height: 26px;
        line-height: 26px;
        padding: 0 12px;
        border-radius: 4px;
        vertical-align: 0.08em;
        .background-primary();
      }
    }
    .product-course {
      position: relative;
      display: inline-block;
      i {
        font-size: 2.4rem;
        line-height: 1;
        color: #2481fc;
        vertical-align: middle;
      }
      &:hover {
        .product-course-ani {
          visibility: visible;
        }
        .product-course-drop {
          visibility: visible;
          transform: translateY(0);
        }
      }
      .product-course-ani {
        position: absolute;
        top: 60px;
        left: 0;
        min-height: 500px;
        width: 700px;
        visibility: hidden;
        overflow: hidden;
        z-index: 200;
      }
      .product-course-drop {
        // position: absolute;
        background-color: #0e182f;
        width: 280px;
        .transTime(0.3s);
        transform: translateY(-100%);
        li {
          position: relative;
          a {
            padding: 0 15px;
            height: 50px;
            line-height: 50px;
            font-size: 14px;
          }
          &:hover {
            // background: #243648;
            .background-primary();
            a {
              color: #fff;
            }
            .course-special {
              display: block;
            }
          }
          & > a {
            display: block;
            color: #fff;
            .ellipsis();
          }
          .course-special {
            display: none;
            position: absolute;
            top: 0;
            left: 280px;
            width: 380px;
            padding: 0 0px 20px 20px;
            background: rgba(255, 255, 255, 0.6);
            line-height: 1;
            .special-item {
              position: relative;
              display: inline-block;
              width: 100px;
              margin-right: 10px;
              margin-top: 20px;
            }
            a {
              display: inline-block;
              color: #666;
              width: 100px;
              height: 30px;
              line-height: 30px;
              background-color: rgba(255, 255, 255, 0.6);
              border-radius: 6px;
              padding: 0 10px;
              font-size: 14px;
              text-align: center;
              .ellipsis();
              &:hover,
              &.selected {
                background-color: rgba(209, 235, 255, 0.9);
                color: #2282fa;
              }
            }
            .can-live {
              position: absolute;
              top: -16px;
              right: -4px;
              width: 70px;
              height: 20px;
              line-height: 20px;
              background-color: #e73d2e;
              color: #fff;
              font-weight: bold;
              border-radius: 3px;
              font-size: 12px;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .prodet-player {
    width: 100%;
    .prodet-box-c {
      float: left;
      width: 800px;
      height: 500px;
      background: #e4ebef;
    }
    .prodet-box-d {
      float: left;
      width: 400px;
      height: 500px;
      background: #1b1b1b;
      .prodet-boxd-a {
        float: left;
        width: 336px;
        height: 500px;
        padding: 12px 0 11px 0;
      }
      .prodet-boxd-b {
        width: 64px;
        height: 500px;
        float: right;
        background: #000;
        position: relative;
        .prodet-pt-a {
          position: relative;
          width: 64px;
          height: 64px;
          padding: 10px 0;
          .background-primary();
          text-align: center;
          color: #fff;
          &:before {
            position: absolute;
            content: " ";
            border: 8px solid transparent;
            border-right: 8px solid #27a3ff;
            bottom: 25px;
            left: -16px;
          }
          i {
            width: 26px;
            height: 26px;
            padding: 2px 0;
            font-size: 22px;
          }
          p {
            font-weight: bold;
            font-size: 12px;
          }
        }
      }
    }
  }
  .prodet-action {
    .prodet-box-f {
      width: 100%;
      padding: 20px 0;
      text-align: right;
      .prodet-boxf-c {
        .inline-block();
        margin-right: 20px;
        color: #f4491b;
        font-size: 32px;
        font-weight: bold;
      }
      .prodet-boxf-b {
        .inline-block();
        font-size: 20px;
        color: #666;
        line-height: 40px;
        margin-right: 20px;
        text-decoration: line-through;
        margin-top: 10px;
      }
      .ivu-btn-warning {
        border: none;
        .background-warning();
        width: 100px;
      }
    }
  }
}

// 通用标题
.product-info-bar {
  width: 200px;
  height: 40px;
  line-height: 40px;
  background: url("../../assets/images/v3/product-detail-title.png") no-repeat
    left center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-indent: 1em;
}

// 商品详情内容
.product-detail {
  width: 800px;
  background: white;
  float: left;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 20px 30px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  .product-info-bar {
    margin-left: -30px;
  }
  .product-info-title {
    padding: 30px 0 10px 0;
    font-size: 22px;
    color: #414141;
  }
  .product-info-sub {
    padding: 30px 0 10px 0;
    font-size: 18px;
    color: #666;
  }
  .product-info-body {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px dashed #ddd;
    li {
      width: 50%;
      color: #666;
      font-size: 16px;
      display: flex;
      margin: 5px 0;
      .info-item {
        span {
          font-size: 22px;
          color: #999;
          line-height: 1;
          vertical-align: -0.1em;
        }
      }
      .info-content {
        flex: 1;
        em {
          font-style: normal;
        }
        span {
          color: #999;
          margin-right: 10px;
        }
      }
    }
  }
  .product-course-list {
    border-bottom: 1px dashed #ddd;
    dl {
      padding-left: 20px;
      dt {
        color: #444;
        font-size: 16px;
      }
      dd {
        display: inline-block;
        margin-right: 20px;
        margin-top: 5px;
        margin-bottom: 20px;
        color: #666;
        font-size: 16px;
      }
    }
  }
  .product-info-textbook {
    font-size: 16px;
    .textbook-name {
      color: #666;
    }
    .textbook-info {
      color: #999;
      margin-top: 10px;
      margin-left: 8px;
      span {
        margin-right: 50px;
      }
    }
  }
  .product-info-detail {
    margin-top: 30px;
    text-align: center;
    width: 100%;
    /deep/img {
      display: inline-block;
    }
  }
}
//侧边栏
.product-sider {
  width: 370px;
  float: right;
  background: #fff;
  margin-top: 30px;
  padding: 20px 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  .product-info-bar {
    margin-left: -10px;
    margin-bottom: 30px;
  }
}
</style>
